import {config} from "../environment";
import FlagProvider from "@unleash/proxy-client-react";
import {ReactNode} from "react";

export function FeatureFlagProvider({children}: { children: ReactNode }) {
  const unleashConfig = {
    url: config.unleashUrl,
    clientKey: config.unleashToken,
    refreshInterval: 15, // How often (in seconds) the client should poll the proxy for updates
    appName: 'kuen',
  }

  return <FlagProvider config={unleashConfig}>
    {children}
  </FlagProvider>
}